var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"outlined":"","type":"success","text":""}},[_vm._v(" Your service project has been submited successfully ")])}
var staticRenderFns = []

export { render, staticRenderFns }